import { styled, Typography } from '@mui/joy';
import { FieldError } from 'react-hook-form';

import { Color, Level } from 'theme/enums';

interface IProps {
  error: FieldError | string;
}

export const FormErrorWrapper = styled(Typography)({
  position: 'relative',
});

const FormErrorView = ({ error }: IProps) => {
  if (!error) {
    return null;
  }

  const errorMsg = ((error as FieldError)?.message || error) as string;

  return (
    <FormErrorWrapper level={Level.BODY_XS} color={Color.DANGER}>
      {errorMsg}
    </FormErrorWrapper>
  );
};

export default FormErrorView;
